import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: 2,
    color: 'fg.muted',
    height: 'full',
    fontSize: 'sm',
    w: 10,
  },
  variants: {
    placement: {
      start: {
        insetInlineStart: '0',
        pointerEvents: 'none',
      },
      end: {
        insetInlineEnd: '0',
        pointerEvents: 'auto',
      },
    },
  },
  defaultVariants: {
    placement: 'start',
  },
});
